import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import ConstElement from '../common/ConstElement';
import HasPermission from '../helper/user.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditTicketRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            job: {work_start_date: null, work_end_date: null,},
            cities:[],
            prefs:[],
            bigCategories:[],
            smallCategories:[],
            hasPermissionCancel:false,
            hasAccepted: false,
        }
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        // this.handleInptChange = this.handleInptChange.bind(this);
        // this.handleStatusChange = this.handleStatusChange.bind(this);
        // this.cancelJob = this.cancelJob.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        // this.renderJobImages = this.renderJobImages.bind(this);
        this.renderListOrderHistories = this.renderListOrderHistories.bind(this);
        this.getJobById = this.getJobById.bind(this);
        this.processClassStatus = this.processClassStatus.bind(this);
        this.processStatus = this.processStatus.bind(this);
        this.RejectedRequest = this.RejectedRequest.bind(this);
        this.renderCategoryName = this.renderCategoryName.bind(this);
        this.renderRewardReceivingStats = this.renderRewardReceivingStats.bind(this);
        this.renderRewardReceivingDate = this.renderRewardReceivingDate.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        HasPermission('/api/ticket_requests/delete').then(permission => {this.setState({hasPermissionCancel: permission})});

        if (this.props.match.params.hasOwnProperty('id')) {
            this.getJobById();
        }
    }

    /**
     * Get job by id
     */
    getJobById() {
        const jobId = this.props.match.params.id
        axios.get('/api/ticket_requests/' + jobId).then(response => {
            if (response.data) {
                this.setData(response.data);
            }
        }).catch(() => {
            this.props.history.push('/_404');
        })
    }

    /**
     * Set data of job
     * data: Object Job
     */
    setData(data) {
        // console.log(data);
        this.setState({
            job: data
        })
    }

    /**
     * Get data of job
     */
    getData() {
        return this.state.job;
    }

    /**
     * Listen change input
     * event: Object input
     */
    // handleInptChange(event) {
    //     let jobData = Object.assign({}, this.state.job);
    //     jobData[event.target.name] = event.target.value;
    //     if (event.target.name === 'staff_total') {
    //         jobData['system_fee']  = Math.ceil(event.target.value * (jobData['define_system_fee'] / 100));
    //         jobData['staff_price'] = event.target.value - jobData['system_fee'];
    //     }
    //     this.setState({job: jobData});
    // }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    /**
     * Call function save data from element parent
     */
    saveData() {
        let job = this.getData();
        //to top
        window.scrollTo(0, 0)
        if (job.hasOwnProperty('id')) {
            axios.post('/api/ticket_requests/edit/' + job.id, job)
            .then(response => {
                if (response.data.success) {
                    toast.success(response.data.message);
                    this.getJobById();
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    // cancelJob(){
    //     let job = this.getData();
    //     if (window.confirm('このチケット申込みをキャンセルしてもよろしいですか？')) {
    //          //to top
    //         window.scrollTo(0, 0)
    //         axios.get('/api/jobs/delete/' + job.id, job).then(response => {
    //             if (response.data.success) {
    //                 toast.success(response.data.message);
    //                 this.setData(response.data.job);
    //             } else if (response.data.error) {
    //                 toast.error(response.data.message);
    //                 this.setData(response.data.job);
    //             } else {
    //                 Object.keys(response.data.errors).map((key, i) => {
    //                         if($.isArray(response.data.errors[key])){
    //                             response.data.errors[key].map((child, i) => {
    //                                 toast.error(child)
    //                             })
    //                         } else {
    //                             toast.error(response.data.errors[key])
    //                         }
    //                     }
    //                 )
    //             }
    //         }).catch(error => {
    //             Object.keys(error.response.data.errors).map((key, i) => {
    //                     if($.isArray(error.response.data.errors[key])){
    //                         error.response.data.errors[key].map((child, i) => {
    //                             toast.error(child)
    //                         })
    //                     } else {
    //                         toast.error(error.response.data.errors[key])
    //                     }
    //                 }
    //             )
    //         })
    //     }
    // }

    /**
     * Handle class with status
     */
    processClassStatus(status) {
        switch(status) {
            case 1:
                return "badge badge-info";
            case 2:
                return "badge badge-danger";
            case 3:
                return "badge badge-warning text-white";
            case 9:
                return "badge badge-dark";
            default:
                return "badge badge-secondary";
        }
    }

    /**
     * Handle show text with status
     */
     processStatus(status) {
        switch(status) {
            case 1:
                return "採用";
            case 2:
                return "不採用";
            case 3:
                return "欠勤";
            case 9:
                return "応募キャンセル";
            default:
                return "未決定";
        }
    }

    /**
     * Handle show text with status
     */
    processCvsStatus(status) {
        switch(status) {
            case 1:
                return "未払い";
            case 2:
                return "支払済み";
            case 3:
                return "期限切れ";
            case 4:
                return "支払停止";
            default:
                return "未決定";
        }
    }

        /**
     * Handle show text with status
     */
    processRequestStatus(status) {
        switch(status) {
            case 0:
                return "承認待ち";
            case 1:
                return "支払い待ち";
            case 2:
                return "予定";
            case 3:
                return "評価待ち";
            case 4:
                return "評価完了";
            case 5:
                return "見送り";
            case 6:
                return "キャンセル";
            default:
                return "承認待ち";
        }
    }

    /**
     * Call function destroy apply job from element parent
     */
     RejectedRequest(){
        let job = this.getData();
        console.log("RejectedRequest : " + job.id);
        axios.get('/api/ticket_requests/reject/' + job.id).then(response => {
            if (response.data.success) {
                toast.success(response.data.message);
                this.setState({current_status: this.state.status})
                this.setData(response.data.HelperTicketRequest);
            } else if (response.data.error) {
                toast.error(response.data.message)
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                        if($.isArray(response.data.errors[key])){
                            response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(response.data.errors[key])
                        }
                    }
                )
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                    if($.isArray(error.response.data.errors[key])){
                        error.response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(error.response.data.errors[key])
                    }
                }
            )
        })
    }

    renderListOrderHistories() {
        let job = this.getData();
        if (job.prepaid_type_flg == 2) {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">クレジット決済のオーダーID</label>
                    <div className="col-sm-8">
                        <label className="col-value text-left text-primary">
                            <a href={'/historyticket/' + job.client_client_id}>クレジット決済履歴</a>
                        </label>
                    </div>
                </div>
            );
        }
        return;
    }

    renderRewardReceivingStats() {
        let job = this.getData();
        if (job.status == 4) {
            return (
            <div className="form-group row">
                <label className="col-sm-4 col-form-label text-right">報酬受け取り</label>
                <div className="col-sm-8">
                    <label className="col-value text-left">{(job.reward_receiving_flg) ? "受け取り済み" : "未受け取り"}</label>
                </div>
            </div>
            );
        }
        return;
    }

    renderRewardReceivingDate() {
        let job = this.getData();
        if (job.status == 4) {
            return (
            <div className="form-group row">
                <label className="col-sm-4 col-form-label text-right">報酬受け取り日時</label>
                <div className="col-sm-8">
                    <label className="col-value text-left">{(job.reward_receiving_at) ? moment(this.state.job.reward_receiving_at).format('YYYY-MM-DD HH:mm') : "" }</label>
                </div>
            </div>
            );
        }
        return;
    }

    handleRenderDestroyJobApply() {
        if (this.state.job.status == 2) {
            return (
                <button onClick={this.destroyJobApply} className="btn btn-danger btn-radius btn-lg ml-1">
                    <span className="size-inherit">確定後キャンセル</span>
                </button>
            );
        }
        return;
    }
    handleRenderRejectedRequest() {
        if (this.state.job.status == 0) {
            return (
                <button onClick={this.RejectedRequest} className="btn btn-danger btn-radius btn-lg ml-1">
                    <span className="size-inherit">申込みをキャンセルにする</span>
                </button>
            );
        }
        return;
    }

    renderCategoryName() {
        let subCategory = this.state.job.helper_sub_category;
        console.log(subCategory);
        if (subCategory) {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right"> チケットタイトル</label>
                    <div className="col-sm-8">
                        <p className="col-value text-left">{subCategory.helper_category.category_name} {subCategory.category_name}</p>
                    </div>
                </div>
            );
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/ticketrequests">チケット申込み一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">チケット申込み確認</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                          <div className="card">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">チケット申込み確認</h4></div>
                            <div className="card-body">
                                <div className="form-group row">
                                <label className="col-sm-4 col-form-label text-right">依頼者</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left text-primary"><a href={"/accounts/edit/" + this.state.job.client_client_id}>{this.state.job.client_first_last_name }</a></label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">チケットID</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left text-primary"><a href={"/tickets/edit/" + this.state.job.helper_ticket_id}>{this.state.job.helper_ticket_id}</a></label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">助っ人名</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left text-primary"><a href={"/accounts/edit/" + this.state.job.worker_client_id}>{this.state.job.worker_first_last_name }</a></label>
                                    </div>
                                </div>
                                {this.renderListOrderHistories()}
                                <div className={this.state.job.combini_order_id ? '' : 'd-none'}>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">コンビニ決済のオーダーID</label>
                                        <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.combini_order_id}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">コンビニ決済のステータス</label>
                                        <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.remittance_completed_flg ? this.processCvsStatus(this.state.job.remittance_completed_flg) : ''}</label>
                                        </div>
                                    </div>
                                </div>
                                {this.renderCategoryName()}
                                {/* <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">チケットタイトル</label>
                                    <div className="col-sm-8">
                                        <span className="col-value text-left">{this.state.job.helper_sub_category.category_name}</span>
                                    </div>
                                </div> */}
                                <div className="form-group row">
                                    <label className="col-sm-4 form-label text-right" htmlFor="">希望日時</label>
                                    <div className="col-sm-8">
                                    {(this.state.job.preferred_date1) ?
                                        <p className="col-value text-left">①{ moment(this.state.job.preferred_date1).format('YYYY-MM-DD HH:mm') }</p>
                                    : ''}

                                    {(this.state.job.preferred_date2) ?
                                        <p className="col-value text-left">②{ moment(this.state.job.preferred_date2).format('YYYY-MM-DD HH:mm') }</p>
                                    : ''}

                                    {(this.state.job.preferred_date3) ?
                                        <p className="col-value text-left">③{ moment(this.state.job.preferred_date3).format('YYYY-MM-DD HH:mm') }</p>
                                    : ''}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 form-label text-right" htmlFor="">開始日</label>
                                    <div className="col-sm-8">
                                        <span className="col-value text-left">{(this.state.job.confirm_date) ? moment(this.state.job.confirm_date).format('YYYY-MM-DD HH:mm') : ""}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right" htmlFor="">終了日</label>
                                    <div className="col-sm-8">
                                    <span className="col-value text-left">{(this.state.job.confirm_date) ? moment(this.state.job.confirm_date).add({hours: this.state.job.working_hours, minutes: this.state.job.working_minute}).format('YYYY-MM-DD HH:mm') : ""}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">所要時間</label>
                                    <div className="col-sm-8">
                                        <span className="col-value text-left">{(this.state.job.working_hours > 0) ? this.state.job.working_hours + "時間" : ""}{(this.state.job.working_minute > 0) ? this.state.job.working_minute + "分" : ""}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">作業場所</label>
                                    <div className="col-sm-8">
                                        <span className="col-value text-left">{this.state.job.work_place}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">作業場所（マスク処理前）</label>
                                    <div className="col-sm-8">
                                        <span className="col-value text-left">{this.state.job.work_place_without_mask}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">ステータス</label>
                                    {/* <div className="col-sm-8">
                                        <ConstElement  element="ticket_request.status" value={this.state.job.status ? this.state.job.status : ''} />
                                    </div> */}
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{this.processRequestStatus(this.state.job.status)}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">報酬金額</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.reward_amount ? '¥' + parseInt(this.state.job.reward_amount).toLocaleString() : 0}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">システム利用料</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{'¥' + parseInt(this.state.job.amount_system_fee).toLocaleString()}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">消費税</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{'¥' + parseInt(this.state.job.amount_system_tax).toLocaleString()}</label>
                                    </div>
                                </div>
                                {/* <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">システム利用料(%)</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.job.system_fee_per + '%'}</label>
                                    </div>
                                </div> */}
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">合計金額</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{'¥' + (parseInt(this.state.job.reward_amount) + parseInt(this.state.job.amount_system_fee) + parseInt(this.state.job.amount_system_tax)).toLocaleString()}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼者からの評価</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{this.state.job.evaluation_from_client}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼者からの評価コメント</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{this.state.job.evaluation_from_client_comment}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼者からの評価コメント（マスク処理前）</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{this.state.job.evaluation_from_client_comment_without_mask}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼者からの評価日時</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{(this.state.job.evaluation_from_client_date) ? moment(this.state.job.evaluation_from_client_date).format('YYYY-MM-DD HH:mm') : ""}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">助っ人からの評価</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{this.state.job.evaluation_from_worker}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">助っ人からの評価コメント</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{this.state.job.evaluation_from_worker_comment}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">助っ人からの評価コメント（マスク処理前）</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{this.state.job.evaluation_from_worker_comment_without_mask}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">助っ人からの評価日時</label>
                                    <div className="col-sm-8">
                                    <label className="col-value text-left">{(this.state.job.evaluation_from_worker_date) ? moment(this.state.job.evaluation_from_worker_date).format('YYYY-MM-DD HH:mm') : ""}</label>
                                    </div>
                                </div>
                                {this.renderRewardReceivingStats()}
                                {this.renderRewardReceivingDate()}
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">作成日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.job.created_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">編集日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.job.updated_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                {/* <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">トラブル区分</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="jobs.trouble_kb" value={this.state.job.trouble_kb ? this.state.job.trouble_kb : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">メモ</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="remark" value={this.state.job.remark ? this.state.job.remark : ""}  className="form-control" rows="8"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">web掲載</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="jobs.web_show_flag" value={this.state.job.web_show_flag} />
                                    </div>
                                </div> */}
                                {/* <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">採用後キャンセル</label>
                                    <div className="col-sm-8">
                                        <input type="checkbox" checked="" className="form-checkbox" disabled/>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-footer">
                                    <div className="text-center">
                                        {this.handleRenderRejectedRequest()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
